import { auth } from './config'
import { onAuthStateChanged, User } from 'firebase/auth'
import store from '@/store'

// Función para inicializar el estado de autenticación
export function initAuth() {
	return new Promise<void>(resolve => {
		// Escuchar cambios en el estado de autenticación
		const unsubscribe = onAuthStateChanged(auth, async (user: User | null) => {
			if (user) {
				// Usuario autenticado - actualizar el store
				store.commit('SET_USER', {
					email: user.email,
					uid: user.uid
				})

				// Cargar todos los datos del usuario
				await store.dispatch('global/loadUserData', null, { root: true })
			} else {
				// Usuario no autenticado - limpiar el store
				store.commit('SET_USER', null)
				store.commit('global/SET_USER_PROFILE', null, { root: true })
			}

			// Resolver la promesa cuando se complete la inicialización
			resolve()
		})

		// Limpiar el listener cuando la aplicación se desmonte
		return () => unsubscribe()
	})
}
